import React from 'react';
import { UPLOAD_SOURCES } from '@cld/upload-widget';
import { asAbsolute } from 'root/routes/utils';
import consts from '../data/consts';
import FacebookTab from '../index';
import ContextPhotos from '../components/ContextPhotos';

export default [
  {
    path: asAbsolute(UPLOAD_SOURCES.FACEBOOK),
    component: FacebookTab,
    routes: [
      {
        path: asAbsolute(UPLOAD_SOURCES.FACEBOOK, 'tagged'),
        render: (props) => <ContextPhotos context={consts.CONTEXTS.TAGGED_PHOTOS} {...props} />,
      },
      {
        path: asAbsolute(UPLOAD_SOURCES.FACEBOOK, 'albums'),
        render: (props) => (
          <ContextPhotos
            context={consts.CONTEXTS.ALBUMS}
            selectionAction={(id) =>
              props.history.push({
                // navigate to album
                pathname: asAbsolute(UPLOAD_SOURCES.FACEBOOK, 'album', id),
                search: props.location.search,
                hash: props.location.hash,
              })
            }
            allowSelect={false}
            {...props}
          />
        ),
      },
      {
        path: asAbsolute(UPLOAD_SOURCES.FACEBOOK, 'album/:id'),
        render: (props) => <ContextPhotos context={consts.CONTEXTS.ALBUM_PHOTOS} contextId={props.match.params.id} {...props} />,
      },
    ],
  },
];
